class ProductAddToCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    this.updateButtonContent();
    this.selectVariantFromURL();

    window.addEventListener("resize", () => this.updateButtonContent());
    this.onVariantChange = this.onVariantChange.bind(this);
    document.addEventListener("variant:change", this.onVariantChange);

  }

  render() {
    const productId = this.getAttribute("data-product-id");
    const variants = JSON.parse(this.getAttribute("data-variants"));
    const pricesMap = this.buildPricesMap();
    const available = this.getAttribute("data-available") === "true";

    if (variants.length === 1 && variants[0].title === "Default Title") {

      this.innerHTML = this.renderSingleVariant(variants[0], available, pricesMap);
    } else {
      this.innerHTML = this.renderWithDropdown(variants, available, pricesMap);
      this.setupDropdown(variants);

      // ✅ Forcer la photo de la première variante si pas d’ID dans l’URL
      const url = new URL(window.location.href);
      const variantIdFromURL = url.searchParams.get("variant");

      // if (!variantIdFromURL) {
      //   const firstVariant = variants[0];
      //   const mainImage = document.querySelector(".product-center .product-image");
      //   const mainImages = document.querySelectorAll(`.product-center .product-image, .product-center-rappel .product-image, .product-sticky-bar__info img`);

      //   mainImages.forEach((img) => {
      //     const newImage = firstVariant.featured_image?.url || firstVariant.featured_image_url || firstVariant.featured_image?.src || null;
      //     if (newImage) {
      //       img.src = newImage;
      //       img.removeAttribute("srcset");
      //       img.removeAttribute("sizes");
      //     }
      //   });
      // }
    }

    this.setupAddToCart(productId); // ✅ Ajout de la fonction ici !
    this.updateButtonContent();
  }

  buildPricesMap() {
    try {
      const prices = JSON.parse(this.getAttribute("data-prices") || "[]");
      const map = new Map();
      prices.forEach(p => map.set(String(p.id), p));
      return map;
    } catch (e) {
      console.warn("data-prices invalide :", e);
      return new Map();
    }
  }

  getPriceHTMLFor(variantId) {
    const prices = this.buildPricesMap();
    const p = prices.get(String(variantId));
    return p ? { priceHTML: p.price_html, compareHTML: p.compare_at_price_html, available: !!p.available } : null;
  }

  renderSingleVariant(variant, available, pricesMap) {
    const p = pricesMap.get(String(variant.id));    return `
      <div class="add-to-cart-container">
        <button type="button" class="add-to-cart-button w100" ${!available ? "disabled" : ""} data-variant-id="${variant.id}">

          <span class="compare-at-price" style="display: ${p && p.compare_at_price_html ? 'inline' : 'none'}; text-decoration: line-through; color: #999;">${p ? p.compare_at_price_html : ""}</span>
          <span class="price">${p ? p.price_html : ""}</span>

          <span class="pipe">|</span>
          <span class="button-content">
            <span class="icon">
              <svg width="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M6.66659 6.66659H5.64771C4.56469 6.66659 4.02363 6.66659 3.63843 6.88754C3.3004 7.08143 3.04056 7.38771 2.90488 7.75301C2.75036 8.16903 2.8393 8.70269 3.01712 9.76964L3.0175 9.77165L3.79527 14.4383C3.92721 15.23 3.99362 15.6259 4.19114 15.923C4.36526 16.1848 4.60967 16.3918 4.89657 16.5205C5.22203 16.6665 5.62314 16.6666 6.4257 16.6666H13.5744C14.3769 16.6666 14.7778 16.6665 15.1032 16.5205C15.3901 16.3918 15.6347 16.1848 15.8088 15.923C16.0064 15.6259 16.0724 15.23 16.2043 14.4383L16.9821 9.77165L16.9829 9.7684C17.1606 8.70228 17.2495 8.16887 17.095 7.75301C16.9593 7.38771 16.7001 7.08143 16.3621 6.88754C15.9769 6.66659 15.4349 6.66659 14.3519 6.66659H13.3333M6.66659 6.66659H13.3333M6.66659 6.66659C6.66659 4.82564 8.15897 3.33325 9.99992 3.33325C11.8409 3.33325 13.3333 4.82564 13.3333 6.66659" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
             </svg>
            </span>
          </span>
        </button>
      </div>
    `;
  }

  renderWithDropdown(variants, available, pricesMap) {
    const first = variants[0];
    const p = pricesMap.get(String(first.id));
    return `
      <div class="add-to-cart-container">
        <div class="custom-select">
          <div class="select-selected" data-variant-id="${first.id}">
            <span>${first.title}</span>
            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-dropdown-chevron" viewBox="0 0 10 6">
              <path d="m1 1 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
            </svg>
          </div>
          <div class="select-items"></div>
        </div>
        <button type="button" class="add-to-cart-button" ${!available ? "disabled" : ""}>
          <span class="compare-at-price" style="display: ${p && p.compare_at_price_html ? 'inline' : 'none'}; text-decoration: line-through; color: #999;">${p ? p.compare_at_price_html : ""}</span>
          <span class="price">${p ? p.price_html : ""}</span>

          <span class="pipe">|</span>
          <span class="button-content"><span class="icon">
              <svg width="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M6.66659 6.66659H5.64771C4.56469 6.66659 4.02363 6.66659 3.63843 6.88754C3.3004 7.08143 3.04056 7.38771 2.90488 7.75301C2.75036 8.16903 2.8393 8.70269 3.01712 9.76964L3.0175 9.77165L3.79527 14.4383C3.92721 15.23 3.99362 15.6259 4.19114 15.923C4.36526 16.1848 4.60967 16.3918 4.89657 16.5205C5.22203 16.6665 5.62314 16.6666 6.4257 16.6666H13.5744C14.3769 16.6666 14.7778 16.6665 15.1032 16.5205C15.3901 16.3918 15.6347 16.1848 15.8088 15.923C16.0064 15.6259 16.0724 15.23 16.2043 14.4383L16.9821 9.77165L16.9829 9.7684C17.1606 8.70228 17.2495 8.16887 17.095 7.75301C16.9593 7.38771 16.7001 7.08143 16.3621 6.88754C15.9769 6.66659 15.4349 6.66659 14.3519 6.66659H13.3333M6.66659 6.66659H13.3333M6.66659 6.66659C6.66659 4.82564 8.15897 3.33325 9.99992 3.33325C11.8409 3.33325 13.3333 4.82564 13.3333 6.66659" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
             </svg>
            </span></span>
        </button>
      </div>
    `;
  }

  selectVariantFromURL() {
    const url = new URL(window.location.href);
    const variantIdFromURL = url.searchParams.get("variant");
    if (!variantIdFromURL) return;

    const variants = JSON.parse(this.getAttribute("data-variants") || "[]");
    const selectedVariant = variants.find(v => v.id.toString() === variantIdFromURL);
    if (!selectedVariant) return;

    // Cas dropdown
    const selectSelected = this.querySelector(".select-selected");
    if (selectSelected) {
      const priceSpan = this.querySelector(".price");
      const compareAtPriceSpan = this.querySelector(".compare-at-price");

      selectSelected.querySelector("span").textContent = selectedVariant.title;
      selectSelected.dataset.variantId = selectedVariant.id;


      // priceSpan.textContent = `${selectedVariant.price / 100} €`;

      // if (selectedVariant.compare_at_price > selectedVariant.price) {
      //   compareAtPriceSpan.textContent = `${selectedVariant.compare_at_price / 100} €`;
      //   compareAtPriceSpan.style.display = "inline";
      // } else {
      //   compareAtPriceSpan.style.display = "none";
      // }
      const p = this.getPriceHTMLFor(selectedVariant.id);
      if (p && priceSpan) priceSpan.innerHTML = p.priceHTML || "";
      if (compareAtPriceSpan) {
        if (p && p.compareHTML) {
          compareAtPriceSpan.innerHTML = p.compareHTML;
          compareAtPriceSpan.style.display = "inline";
        } else {
          compareAtPriceSpan.style.display = "none";
        }

      }


      // Mettre à jour l’image principale
      const mainImage = document.querySelector(".product-center .product-image");
      if (mainImage && selectedVariant.featured_image?.src) {
        mainImage.src = selectedVariant.featured_image.src;
      }
      // Mettre à jour l’image rappel
      const mainImage2 = document.querySelector(".product-center-rappel .product-image");
      if (mainImage2 && selectedVariant.featured_image?.src) {
        mainImage2.src = selectedVariant.featured_image.src;
      }
      const stickyimg = document.querySelector('.product-sticky-bar__info img')
      if (stickyimg && selectedVariant.featured_image?.src) {
        stickyimg.src = selectedVariant.featured_image.src;
        stickyimg.removeAttribute("srcset");
        stickyimg.removeAttribute("sizes");
      }
    }

    // Cas bouton sans dropdown
    const singleButton = this.querySelector(".add-to-cart-button");
    if (singleButton && !selectSelected) {
      singleButton.dataset.variantId = selectedVariant.id;
    }
  }


  setupDropdown(variants) {
    const selectSelected = this.querySelector(".select-selected");
    const selectItems = this.querySelector(".select-items");
    const priceSpan = this.querySelector(".price");
    const compareAtPriceSpan = this.querySelector(".compare-at-price");

    selectItems.innerHTML = "";
    variants.forEach((variant) => {
      const optionDiv = document.createElement("div");
      optionDiv.textContent = variant.title;
      optionDiv.dataset.variantId = variant.id;
      // optionDiv.dataset.variantPrice = variant.price / 100;
      // optionDiv.dataset.variantCompareAtPrice = variant.compare_at_price / 100 || "";

      optionDiv.addEventListener("click", () => {
        selectSelected.querySelector("span").textContent = variant.title;
        selectSelected.dataset.variantId = variant.id;
        // priceSpan.textContent = `${variant.price / 100} €`;

        // if (variant.compare_at_price > variant.price) {
        //   compareAtPriceSpan.textContent = `${variant.compare_at_price / 100} €`;
        //   compareAtPriceSpan.style.display = "inline";
        // } else {
        //   compareAtPriceSpan.style.display = "none";
        // }
        const p = this.getPriceHTMLFor(variant.id);
        if (p && priceSpan) priceSpan.innerHTML = p.priceHTML || "";
        if (compareAtPriceSpan) {
          if (p && p.compareHTML) {
            compareAtPriceSpan.innerHTML = p.compareHTML;
            compareAtPriceSpan.style.display = "inline";
          } else {
            compareAtPriceSpan.style.display = "none";
          }

        }

        // ✅ Mise à jour de l’image uniquement au clic

        const mainImage = document.querySelector(".product-center .product-image");


        const mainImages = document.querySelectorAll(`.product-center .product-image, .product-center-rappel .product-image, .product-sticky-bar__info img`);

        mainImages.forEach((img) => {
          const newImage = variant.featured_image?.url || variant.featured_image_url || variant.featured_image?.src || null;
          if (newImage) {
            img.src = newImage;
            img.removeAttribute("srcset");
             img.removeAttribute("sizes");
          }
        });


        // ✅ Mise à jour URL
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);

        // 🔁 Dispatch d’un événement pour synchroniser tous les composants
        document.dispatchEvent(new CustomEvent("variant:change", {
          detail: {
            productId: this.getAttribute("data-product-id"),
            variant
          }
        }));

        window.history.replaceState({}, "", url);

        selectSelected.classList.remove("active");
        selectItems.classList.add("select-hide");
      });

      selectItems.appendChild(optionDiv);
    });

    selectSelected.addEventListener("click", (e) => {
      e.stopPropagation();
      const isActive = selectSelected.classList.toggle("active");

      const isSticky = this.classList.contains("sticky-variant-selector");
      if (isActive) {
        selectItems.classList.remove("select-hide");

        if (isSticky) {
          selectItems.style.bottom = `${selectSelected.offsetHeight}px`;
          selectItems.style.top = "auto";
        } else {
          selectItems.style.top = `${selectSelected.offsetHeight}px`;
          selectItems.style.bottom = "auto";
        }

      } else {
        selectItems.classList.add("select-hide");
      }
    });

    document.addEventListener("click", () => {
      selectSelected.classList.remove("active");
      selectItems.classList.add("select-hide");
    });
  }

  updateButtonContent() {
    const usePictoAlways = this.getAttribute("data-picto") === "true";
    const usePictoResponsive = window.innerWidth < 1100 && window.innerWidth > 960 || window.innerWidth < 360;
    const usePicto = usePictoAlways || usePictoResponsive;
    const buttonContentSpan = this.querySelector(".button-content");

    if (!buttonContentSpan) {
      console.error("❌ Erreur : le span.button-content est introuvable !");
      return;
    }

    const labels = JSON.parse(this.getAttribute("data-labels") || '{"addToCart": "Ajouter", "outOfStock": "Rupture"}');
    const available = this.getAttribute("data-available") === "true";

    buttonContentSpan.innerHTML = usePicto
      ? `<span class="icon">
          <svg width="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M6.66659 6.66659H5.64771C4.56469 6.66659 4.02363 6.66659 3.63843 6.88754C3.3004 7.08143 3.04056 7.38771 2.90488 7.75301C2.75036 8.16903 2.8393 8.70269 3.01712 9.76964L3.0175 9.77165L3.79527 14.4383C3.92721 15.23 3.99362 15.6259 4.19114 15.923C4.36526 16.1848 4.60967 16.3918 4.89657 16.5205C5.22203 16.6665 5.62314 16.6666 6.4257 16.6666H13.5744C14.3769 16.6666 14.7778 16.6665 15.1032 16.5205C15.3901 16.3918 15.6347 16.1848 15.8088 15.923C16.0064 15.6259 16.0724 15.23 16.2043 14.4383L16.9821 9.77165L16.9829 9.7684C17.1606 8.70228 17.2495 8.16887 17.095 7.75301C16.9593 7.38771 16.7001 7.08143 16.3621 6.88754C15.9769 6.66659 15.4349 6.66659 14.3519 6.66659H13.3333M6.66659 6.66659H13.3333M6.66659 6.66659C6.66659 4.82564 8.15897 3.33325 9.99992 3.33325C11.8409 3.33325 13.3333 4.82564 13.3333 6.66659" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                     </svg>
        </span>`
      : `<span class="icon-text">${available ? labels.addToCart : labels.outOfStock}</span>`;
  }

  setupAddToCart(productId) {
    const addToCartButton = this.querySelector(".add-to-cart-button");

    addToCartButton.addEventListener("click", () => {
      let variantId = this.querySelector(".select-selected")?.dataset.variantId || addToCartButton.dataset.variantId;

      if (!variantId) {
        console.error("❌ Erreur : Aucun variant sélectionné !");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) throw new Error("⚠️ Échec de l'ajout au panier");
          return response.json();
        })
        .then(() => {
          console.log("✅ Produit ajouté au panier !");
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          const cartDrawerLink = document.querySelector('a[aria-controls="cart-drawer"]');
          if (cartDrawerLink) cartDrawerLink.click();
        })
        .catch(console.error);
    });
  }

  onVariantChange(event) {
    const { productId, variant } = event.detail;

    // Ne pas réagir si ce n’est pas le même produit
    if (this.getAttribute("data-product-id") !== productId) return;

    const selectSelected = this.querySelector(".select-selected");
    const priceSpan = this.querySelector(".price");
    const compareAtPriceSpan = this.querySelector(".compare-at-price");
    const addToCartButton = this.querySelector(".add-to-cart-button");

    if (selectSelected) {
      selectSelected.querySelector("span").textContent = variant.title;
      selectSelected.dataset.variantId = variant.id;
    }

    // if (priceSpan) priceSpan.textContent = `${variant.price / 100} €`;


    // if (compareAtPriceSpan) {
    //   if (variant.compare_at_price > variant.price) {
    //     compareAtPriceSpan.textContent = `${variant.compare_at_price / 100} €`;
    //     compareAtPriceSpan.style.display = "inline";
    //   } else {
    //     compareAtPriceSpan.style.display = "none";
    //   }
    // }
    const p = this.getPriceHTMLFor(variant.id);
    if (priceSpan && p) priceSpan.innerHTML = p.priceHTML || "";
    if (compareAtPriceSpan) {
      if (p && p.compareHTML) {
        compareAtPriceSpan.innerHTML = p.compareHTML;

        compareAtPriceSpan.style.display = "inline";
      } else {
        compareAtPriceSpan.style.display = "none";
      }
    }

    if (addToCartButton) {
      addToCartButton.dataset.variantId = variant.id;
    }

    const newImage = variant.featured_image?.url || variant.featured_image_url || variant.featured_image?.src || null;
    const mainImages = document.querySelectorAll(`.product-center .product-image, .product-center-rappel .product-image, .product-sticky-bar__info img`);

    mainImages.forEach((img) => {
      if (newImage) {
        img.src = newImage;
        img.removeAttribute("srcset");
        img.removeAttribute("sizes");
      }
    });
  }


  disconnectedCallback() {
    document.removeEventListener("variant:change", this.onVariantChange);
  }


}

customElements.define("product-add-to-card", ProductAddToCard);
